import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Common/Reducers/wrapperReducer";
import HighestOI from "./highestOI";
import { EOptionDrivingMarketSectionType } from "@domains/features/Markets/Options/entites/drivingMarket";
import HighestGainer from "./highestGainer";
import HighestLoser from "./highestLosers";
import highestVolume from "./highestVolume";
export default combineReducers({
    highestOI: createNamedWrapperReducer(HighestOI, EOptionDrivingMarketSectionType.HIGHEST_OI),
    highestOIGainer: createNamedWrapperReducer(HighestGainer, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER),
    highestOILoser: createNamedWrapperReducer(HighestLoser, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER),
    highestVolume: createNamedWrapperReducer(highestVolume, EOptionDrivingMarketSectionType.HIGHEST_VOLUME),
});
